module.exports = __webpack_public_path__ + "static/media/Trauma.3e2bd1ea.mp4";